import { render, staticRenderFns } from "./CtaContent.vue?vue&type=template&id=031c83a4"
import script from "./CtaContent.vue?vue&type=script&lang=js"
export * from "./CtaContent.vue?vue&type=script&lang=js"
import style0 from "./CtaContent.vue?vue&type=style&index=0&id=031c83a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports